import { Injectable } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { OpenDialogService } from 'src/app/common/open-dialog/open-dialog.service';
import { ReportableEntityEnum } from 'src/types/graphql';
import { getDefaultModalSettings } from 'src/app/common/utils/helpers';
import { ReportDialogComponent } from '../../dialogs/report-dialog/report-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class ReportService {
  constructor(private openDialogService: OpenDialogService) {}

  openDialog(data: {
    isCreate?: boolean;
    isPlaceUtility?: boolean;
    isSharryManagement?: boolean;
    reportedEntityId: any;
    reportedEntityType: ReportableEntityEnum;
    showBlock?: boolean;
  }): MatDialogRef<ReportDialogComponent> {
    return this.openDialogService.openDialog(ReportDialogComponent, {
      ...getDefaultModalSettings(),
      data: data || {},
    });
  }
}
